import React from 'react';
import { Navigate } from 'react-router';
import { OtherMenu } from '@/components/OtherMenu';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Layout } from '@/layouts/Layout';
import { ROUTE_HOME } from '@/router/routes';

export const Other: React.FC = () => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return <Navigate to={ROUTE_HOME} replace />;
  }

  return (
    <Layout>
      <OtherMenu />
    </Layout>
  );
};
